import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { getElasticEvents } from "../../../services/ReportingService";
import ElasticLineChart, { LineOptions } from "./ElasticLineChart";
import { ESQuery } from "../../../services/ESQueries";

interface GraphBoxProps {
    esQuery: ESQuery;
    title: string;
    subtitle: string;
    label: string;
}

type ParsedData = { data: any[], index: number };

const GraphBox = (props: GraphBoxProps) => {

    //const mockData = {"data_histogram":{"doc_count":32,"filtered_events":{"buckets":[{"key_as_string":"2024-06-19 00:00:00","key":1718755200000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-20 00:00:00","key":1718841600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-21 00:00:00","key":1718928000000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-22 00:00:00","key":1719014400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-23 00:00:00","key":1719100800000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-24 00:00:00","key":1719187200000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-25 00:00:00","key":1719273600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-26 00:00:00","key":1719360000000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-27 00:00:00","key":1719446400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-28 00:00:00","key":1719532800000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-29 00:00:00","key":1719619200000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-06-30 00:00:00","key":1719705600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-01 00:00:00","key":1719792000000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-02 00:00:00","key":1719878400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-03 00:00:00","key":1719964800000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-04 00:00:00","key":1720051200000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-05 00:00:00","key":1720137600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-06 00:00:00","key":1720224000000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-07 00:00:00","key":1720310400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-08 00:00:00","key":1720396800000,"doc_count":25,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":19},{"key":"clicked","doc_count":6}]}},{"key_as_string":"2024-07-09 00:00:00","key":1720483200000,"doc_count":1,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":1}]}},{"key_as_string":"2024-07-10 00:00:00","key":1720569600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-11 00:00:00","key":1720656000000,"doc_count":1,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":1}]}},{"key_as_string":"2024-07-12 00:00:00","key":1720742400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-13 00:00:00","key":1720828800000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-14 00:00:00","key":1720915200000,"doc_count":1,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":1}]}},{"key_as_string":"2024-07-15 00:00:00","key":1721001600000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-16 00:00:00","key":1721088000000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-17 00:00:00","key":1721174400000,"doc_count":0,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[]}},{"key_as_string":"2024-07-18 00:00:00","key":1721260800000,"doc_count":1,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":1}]}},{"key_as_string":"2024-07-19 00:00:00","key":1721347200000,"doc_count":3,"event_data.tracking_type":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"clicked","doc_count":2},{"key":"opened","doc_count":1}]}}]}},"field_aggs":{"doc_count":32,"eventdata":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"opened","doc_count":24},{"key":"clicked","doc_count":8}]}},"total_events":{"doc_count":32}}; 

    const { esQuery, title, subtitle, label } = props;

    const [graphData, setGraphData] = useState({ data: [], labels: [] });
    const [esData, setESData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    const [total, setTotal] = useState(0);

    const lineOptions = LineOptions();

    useEffect(() => {

        if (esQuery.distinct) {
            setTotal(esData?.total_distinct_sessions?.distinct_sessions_count.value);
        }
        else {
            setTotal(esData?.total_events?.doc_count);
        }
    }, [esData]);

    useEffect(() => {

        getElasticEvents(esQuery.getQuery())
            .then((res) => {
                let rawData = _mapper(res.data);

                setESData(res.data);
                setGraphData(rawData);
                setLoading(false);
            });

    }, []);

    let _mapper = (data) => {

        var xAxisLabel: string[] = [];
        var yAxisData: any[] = [];

        if (esQuery.multiAgg && esQuery.aggField) {

            const datasetKeys = data.field_aggs?.eventdata?.buckets;
            const buckets = data.data_histogram?.filtered_events?.buckets;

            const parsedData: Map<string, ParsedData> = new Map();

            datasetKeys.forEach((key, i) => {
                parsedData.set(key.key, { data: [], index: i });
            });

            for (const bucket of buckets) {

                xAxisLabel.push(bucket?.key_as_string);

                let subBucket = bucket[esQuery.aggField]?.buckets;

                datasetKeys.forEach((element, i) => {
                    parsedData.get(element.key)?.data.push(0);
                });


                subBucket.forEach((element, i) => {

                    const len = parsedData.get(element.key)?.data?.length;
                    const data = parsedData.get(element.key)?.data;
                    
                    if (len && data) {
                        data[len - 1] = element.doc_count;
                    }

                });
            }

            parsedData.forEach((value, key) => {

                const line = lineOptions.all[value.index % lineOptions.all.length];

                yAxisData.push({
                    label: key,
                    data: value.data,
                    ...line
                });

            });

        } else {

            const parsedData: ParsedData = { data: [], index: 0 };

            const buckets = data.data_histogram?.filtered_events?.buckets;
            for (const bucket of buckets) {

                xAxisLabel.push(bucket?.key_as_string);

                if (esQuery.distinct)
                    parsedData.data.push(bucket.distinct_sessions_count.value);
                else
                    parsedData.data.push(bucket.doc_count);
            }

            yAxisData = [
                {
                    label: label,
                    data: parsedData.data,
                    ...lineOptions.primary
                }
            ];
        }
        return {
            datasets: yAxisData,
            labels: xAxisLabel
        };
    }


    return (
        <>
            {loading
                ?
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                    <FontAwesomeIcon style={{ color: "#b4b4b4" }} size={"3x"} icon={faChartLine} className="fa-thin" beatFade />
                </div>

                : <div className="card">
                    <div className="card-body">
                        <h5 className="card-title font-weight-bolder">{title}</h5>
                        <div className="mb-5 pb-3" style={{ borderBottom: "1px solid #b4b4b4" }}>
                            <div className="text-xl">{total}</div>
                            <div className="text-gray-600">{subtitle}</div>

                        </div>
                        <div>
                            {<ElasticLineChart graphData={graphData} xUnit={5} />}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default GraphBox;